import React from "react";
import { Translation } from "react-i18next";
import "../../../../css/Suggestions.css";
import { ROOT } from "../../../../constants";
import i18next from "i18next";
import Swiper from "swiper";

let suggestionsSwiper;

class Suggestions extends React.Component {
  componentDidMount() {
    suggestionsSwiper = new Swiper(".suggestions_wrapper .swiper-container", {
      slidesPerView: 5,
      spaceBetween: 0,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        prevEl: ".suggestions_button_prev",
        nextEl: ".suggestions_button_next"
      },

      breakpoints: {
        991: {
          slidesPerView: 3,
          allowTouchMove: true
        }
      }
    });
  }

  componentDidUpdate(prevProps) {
    suggestionsSwiper.update();
  }

  render() {
    const { suggestions, language } = this.props;

    return (
      <div className="suggestions_wrapper">
        <div className="set_title">
          <div className="text">
            <Translation>{t => <>{t("suggestions.title")}</>}</Translation>
          </div>
          {/* <a className="more">
            <Translation>{t => <>{t("suggestions.more")}</>}</Translation>
          </a> */}
        </div>
        <div className="swiper-container set_swiper">
          <div className="swiper-wrapper">
            {suggestions.map((data, index) => (
              <div className="swiper-slide" key={index}>
                <div className="swiper-slide">
                  <a
                    href={`${ROOT}/${language}/productDetail/${data.catalogItemCode}`}
                  >
                    <img src={data.listImageUrl} alt="" />
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="swiper-button-next suggestions_button_next"></div>
          <div className="swiper-button-prev suggestions_button_prev"></div>
        </div>
      </div>
    );
  }
}
export default Suggestions;
